import { gql } from "@apollo/client";

import { TIMER_INFO, TRADE_INFO, TRADE_INFO_NO_MEMBER } from "../fragments";

export const GET_ASSET_SYMBOL_LIST = gql`
  query symbolList {
    symbolList {
      symbol
      name
      price
      exchange
      exchangeShortName
      type
      logo
    }
  }
`;

export const GET_SYMBOL_TIMERS = gql`
  query symbolTimers {
    symbolTimers {
      ...timerInfo
    }
  }
  ${TIMER_INFO}
`;

export const GET_MY_TRADES = gql`
  query myTradeList($status: String!) {
    myTradeList(status: $status) {
      ...tradeInfo
    }
  }
  ${TRADE_INFO}
`;

export const COUNT_MY_TRADES = gql`
  query countMyTrades {
    countMyTrades
  }
`;

export const GET_MY_TRADE_DETAIL = gql`
  query myTradeDetail($id: ID!) {
    myTradeDetail(id: $id) {
      ...tradeInfoNoMember
    }
  }
  ${TRADE_INFO_NO_MEMBER}
`;

export const GET_BET_OPTIONS = gql`
  query betOptions {
    betOptions {
      id
      name
      engName
      options {
        id
        name
        engName
        profit
      }
    }
  }
`;

export const GET_BET_LIST = gql`
  query getBetList {
    getBetList {
      ...betInfo
    }
  }
  ${TRADE_INFO}
`;

export const INVESTMENT_RECORD = gql`
  query investmentRecord {
    investmentRecord {
      ...betInfo
    }
  }
  ${TRADE_INFO}
`;
